import "./BrandIdentity.css";
import backgroundImage from ".././Brand-Identity/Assets/Urban-Background.jpg";
import { motion, useScroll, useTransform } from "framer-motion";
import react, { useRef } from "react";
import backgroundImage2 from "../../header-background-images/Header-Background-2.jpg";
import backgroundimage3 from "../../header-background-images/Header-Background.jpg";

function BrandIdentity() {
  return (
    <section className="brand-identity-section">
      <motion.div className="grid-section grid-1">
        <div className="left-column">
          <motion.h1
            className="identity-title"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }} // 👈 THIS
          >
            where urban dreams took root
          </motion.h1>
          <motion.p
            className="identity-text-description"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            In a city that never slows down, Urban Luxe Realty emerged with a
            clear purpose: to redefine what it means to live exceptionally.
            Founded in 2010 by a team passionate about modern architecture,
            timeless design, and personal connection, we've spent over a decade
            turning properties into meaningful homes. Our focus goes beyond
            square footage — we curate spaces that match your lifestyle, your
            rhythm, and your vision. From boutique lofts to luxury estates, we
            guide our clients with precision, care, and a commitment to
            excellence that's felt in every detail. We don't just sell homes —
            we build relationships that last long after the keys are handed
            over.
          </motion.p>
          <motion.div
            className="identity-btn-wrapper"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <a href="#" className="identity-btn">
              enroll now
            </a>
            <a href="#" className="identity-btn-2">
              list of properties
            </a>
          </motion.div>
        </div>
        <motion.div
          className="right-column"
          initial={{ opacity: 0, y: 200 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <div className="overlay-image"></div>
          <img
            className="right-column-image"
            src={backgroundImage}
            alt="Background"
          />
        </motion.div>
      </motion.div>
      <motion.div className="grid-section grid-2">
        <motion.div
          className="grid-2-left-column"
          initial={{ opacity: 0, y: 200 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <div className="overlay-image"></div>
          <img
            src={backgroundImage2}
            className="left-column-img"
            alt="image of a property"
          />
        </motion.div>
        <div className="grid-2-right-column">
          <motion.h1
            className="identity-title"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }} // 👈 THIS
          >
            from local spark to citywide standard
          </motion.h1>
          <motion.p
            className="identity-text-description"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            From our humble beginnings in a single neighborhood, Urban Luxe
            quickly became more than just a name — we became a movement. With
            every project, we refined our craft, expanded our reach, and built a
            reputation for turning spaces into statements. As the city grew, so
            did we — not by chasing trends, but by setting standards. Today, our
            footprint spans across the most sought-after districts, backed by a
            team that brings both vision and precision to every property we
            touch.
          </motion.p>
          <motion.div
            className="identity-btn-wrapper"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <a href="#" className="identity-btn">
              enroll now
            </a>
            <a href="#" className="identity-btn-2">
              list of properties
            </a>
          </motion.div>
        </div>
      </motion.div>
      <motion.div className="grid-section grid-3">
        <div className="left-column">
          <motion.h1
            className="identity-title"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }} // 👈 THIS
          >
            shaping tommorow, one step at a time
          </motion.h1>
          <motion.p
            className="identity-text-description"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            With a foundation built on trust and a reputation earned through
            results, Urban Luxe Realty is more than a brand — it's a vision for
            how real estate should feel. As we look to the future, we remain
            committed to innovation, personalization, and creating not just
            homes, but experiences that elevate everyday life. From emerging
            neighborhoods to iconic cityscapes, we continue to lead with heart,
            precision, and a belief that luxury is defined by how well a space
            serves the people in it.
          </motion.p>
          <motion.div
            className="identity-btn-wrapper"
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5 }}
            viewport={{ once: true, amount: 0.5 }}
          >
            <a href="#" className="identity-btn">
              enroll now
            </a>
            <a href="#" className="identity-btn-2">
              list of properties
            </a>
          </motion.div>
        </div>
        <motion.div
          className="right-column"
          initial={{ opacity: 0, y: 200 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <div className="overlay-image"></div>
          <img
            className="right-column-image"
            src={backgroundimage3}
            alt="Background"
          />
        </motion.div>
      </motion.div>
    </section>
  );
}

export default BrandIdentity;
